module.exports = {
  missingRequired: 'You must enter a value for required feilds!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  'Web:User Login userName cannot be null or empty': 'Username cannot be null or empty',
  'Web:User Login password cannot be null or empty': 'Password cannot be null or empty',
  'Error in fields': 'Error in fields',
  'Access Denied': 'Access Denied',
  'Company:Create Duplicate oosId.': 'Duplicate oosId.',
  'Company:Create OosId cannot be null.': 'OosId cannot be null.',
  'Company:Create Duplicate name.': 'Duplicate name.',
  'Company:Create Invalid currency code.': 'Invalid currency code.',
  'Company:Create Test cannot be null.': 'Test cannot be null.',
  'Company:Create Address Line1 cannot be null or empty.': 'Address Line1 cannot be null or empty.',
  'Company:Create Address Town City cannot be null or empty.': 'Address Town City cannot be null or empty.',
  'Company:Create Address Country cannot be null or empty.': 'Address Country cannot be null or empty.',
  'Company:Create Address PostalCode cannot be null or empty.': 'Address PostalCode cannot be null or empty.',
  'Company:Create Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Create Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Create Invalid Email.': 'Invalid Email.',
  'Company:Update Duplicate oosId': 'Duplicate oosId',
  'Company:Update OosId cannot be null.': 'OosId cannot be null.',
  'Company:Update Duplicate name.': 'Duplicate name.',
  'Company:Update Invalid currency code.': 'Invalid currency code.',
  'Company:Update Test cannot be null.': 'Test cannot be null.',
  'Company:Update Failed to update company details.': 'Failed to update company details.',
  'Company:Update Name cannot be null or empty.': 'Name cannot be null or empty.',
  'Company:Update Currency cannot be null or empty.': 'Currency cannot be null or empty.',
  'Company:Update Invalid Email.': 'Invalid Email.',
  'Company:Get Company not found.': 'Company not found.',
  'Company:Activate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
  'Request method \'POST\' not supported': 'Request method \'POST\' not supported',
  'Company:Deactivate Failed to update company status. Invalid company id': 'Failed to update company status. Invalid company id',
};




// WEBPACK FOOTER //
// ./src/lang/fa/errors.js